import { type ReactNode, useMemo, useEffect } from 'react';
import { WorkspaceService } from './workspace-service';
import { useSyncSystem } from '@/lib/sync/sync-system-context';
import { WorkspaceServiceContext } from './use-workspace-service';
import { setWorkspaceService } from './workspace-service-singleton';
import { YjsRegistryContext } from '@/lib/sync/hooks/yjs-registry-context';

export function WorkspaceServiceProvider({ children }: { children: ReactNode }) {
  const sys = useSyncSystem();

  const service = useMemo(() => {
    return new WorkspaceService(sys.registry);
  }, [sys]);

  useEffect(() => {
    setWorkspaceService(service);
  }, [service]);

  return (
    <YjsRegistryContext.Provider value={sys.registry}>
      <WorkspaceServiceContext.Provider value={service}>
        {children}
      </WorkspaceServiceContext.Provider>
    </YjsRegistryContext.Provider>
  );
}
